import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";

import Loader from "../layout/Loader";
import AdminProfile from "../user/AdminProfile";
import { useGetUserDetailsQuery, useUpdateUserMutation } from "../../redux/api/userApi";
import { Helmet } from "react-helmet-async";

const UpdateUser = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");

  const navigate = useNavigate();
  const params = useParams();

  const { data, isLoading, error } = useGetUserDetailsQuery(params?.id);
  const [updateUser, { isSuccess, error: updateError }] = useUpdateUserMutation();

  useEffect(() => {
    if (data?.user) {
      setName(data?.user?.name);
      setEmail(data?.user?.email);
      setRole(data?.user?.role);
    }
  }, [data]);

  useEffect(() => {
    if (error) toast.error(error?.data?.message);
    if (updateError) toast.error(updateError?.data?.message);

    if (isSuccess) {
      toast.success("User Updated");
      navigate("/admin/users");
    }
  }, [error, updateError, isSuccess, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    updateUser({ id: params?.id, body: { name, email, role } });
  };

  if (isLoading) return <Loader />;

  return (
    <AdminProfile>
        <Helmet>
        <title>Update User</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="w-full mx-auto mt-10 bg-[#f5f3ea] rounded-lg shadow border border-[#e2e1d8] p-6">
        <h2 className="text-2xl font-playfair text-[#1c1917] mb-6">Update User</h2>

        <form className="space-y-4" onSubmit={submitHandler}>
          <div>
            <label htmlFor="name_field" className="block text-[#1c1917] font-sourcesans mb-1">
              Name
            </label>
            <input
              type="text"
              id="name_field"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full border border-[#e2e1d8] rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#BC3F4A]"
            />
          </div>

          <div>
            <label htmlFor="email_field" className="block text-[#1c1917] font-sourcesans mb-1">
              Email
            </label>
            <input
              type="email"
              id="email_field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-[#e2e1d8] rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#BC3F4A]"
            />
          </div>

          <div>
            <label htmlFor="role_field" className="block text-[#1c1917] font-sourcesans mb-1">
              Role
            </label>
            <select
              id="role_field"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="w-full border border-[#e2e1d8] rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#BC3F4A]"
            >
              <option value="user">user</option>
              <option value="admin">admin</option>
            </select>
          </div>

          <button
            type="submit"
            className="w-full bg-[#BC3F4A] text-white py-2 rounded hover:bg-[#8a4b32] transition"
          >
            Update
          </button>
        </form>
      </div>
    </AdminProfile>
  );
};

export default UpdateUser;
